import React from 'react';
import { motion } from 'framer-motion';
import { Scale } from 'lucide-react';
export function CostComparison() {
  const tableData = [{
    bad: '3 horas semanales buscando prompts que no funcionan',
    cost: '150 horas de tu vida por año'
  }, {
    bad: 'Resultados genéricos que reescribís igual',
    cost: 'Doble trabajo, mitad de impacto'
  }, {
    bad: 'Sin saber cuál IA usar para cada tarea',
    cost: 'Las 3 herramientas al 20% de su capacidad'
  }, {
    bad: 'Contenido que parece IA y nadie comparte',
    cost: 'Algoritmo que te entierra'
  }, {
    bad: 'Tareas que siguen tardando horas "con IA"',
    cost: 'La IA no ahorra tiempo sin el flujo correcto'
  }, {
    bad: 'Semana tras semana el mismo ciclo',
    cost: 'El próximo año en las mismas'
  }];
  return <section className="py-24 bg-dark relative" data-id="element-49">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-51">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-white flex items-center justify-center gap-4" data-id="element-52">
            <Scale className="w-10 h-10 text-cyan-400" data-id="element-53" />
            ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="glass-card rounded-2xl overflow-hidden border border-white/10" data-id="element-54">
          <div className="overflow-x-auto" data-id="element-55">
            <table className="w-full text-left border-collapse" data-id="element-56">
              <thead data-id="element-57">
                <tr className="bg-white/5 border-b border-white/10" data-id="element-58">
                  <th className="py-4 px-6 text-gray-300 font-semibold w-1/2" data-id="element-59">
                    Sin Mega Pack IA
                  </th>
                  <th className="py-4 px-6 text-red-400 font-semibold w-1/2 border-l border-white/10" data-id="element-60">
                    Costo real
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-61">
                {tableData.map((row, i) => <tr key={i} className="border-b border-white/5 hover:bg-white/5 transition-colors last:border-0" data-id="element-62">
                    <td className="py-4 px-6 text-gray-400" data-id="element-63">{row.bad}</td>
                    <td className="py-4 px-6 text-white font-medium border-l border-white/10 bg-red-500/5" data-id="element-64">
                      {row.cost}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-16 text-center" data-id="element-65">
          <p className="text-2xl md:text-3xl font-display font-bold text-cyan-400 italic" data-id="element-66">
            "El próximo lunes puede ser diferente."
          </p>
        </motion.div>
      </div>
    </section>;
}